/**
 * New DPD Distribution Chart - Horizontal bars showing loan distribution by days past due
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Link } from 'react-router-dom';

export function NewDPDDistribution({ stats }) {
  const totalLoans = (stats?.dpd_current || 0) + (stats?.dpd_1_30 || 0) + 
                     (stats?.dpd_31_60 || 0) + (stats?.dpd_61_90 || 0) + 
                     (stats?.dpd_90_plus || 0);

  const calculatePercentage = (count) => {
    if (totalLoans === 0) return 0;
    return ((count / totalLoans) * 100).toFixed(1);
  };

  const dpdData = [
    { 
      label: 'Current', 
      count: stats?.dpd_current || 0, 
      percentage: parseFloat(calculatePercentage(stats?.dpd_current || 0)), 
      color: 'bg-green-500' 
    },
    { 
      label: '1-30', 
      count: stats?.dpd_1_30 || 0, 
      percentage: parseFloat(calculatePercentage(stats?.dpd_1_30 || 0)), 
      color: 'bg-blue-500' 
    },
    { 
      label: '31-60', 
      count: stats?.dpd_31_60 || 0, 
      percentage: parseFloat(calculatePercentage(stats?.dpd_31_60 || 0)), 
      color: 'bg-yellow-500' 
    },
    { 
      label: '61-90', 
      count: stats?.dpd_61_90 || 0, 
      percentage: parseFloat(calculatePercentage(stats?.dpd_61_90 || 0)), 
      color: 'bg-orange-500' 
    },
    { 
      label: '90+', 
      count: stats?.dpd_90_plus || 0, 
      percentage: parseFloat(calculatePercentage(stats?.dpd_90_plus || 0)), 
      color: 'bg-red-500' 
    },
  ];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg font-semibold">DPD Distribution</CardTitle>
        <Link to="/demands/overdue" className="text-sm text-primary hover:underline">
          View details
        </Link>
      </CardHeader>
      <CardContent className="space-y-2">
        {dpdData.map((item, index) => (
          <div key={index} className="flex items-center gap-3">
            {/* Label on left */}
            <span className="text-sm text-muted-foreground w-16 flex-shrink-0">
              {item.label}
            </span>
            
            {/* Progress bar in middle */}
            <div className="relative flex-1 h-3 bg-muted rounded-full overflow-hidden">
              <div
                className={`absolute left-0 top-0 h-full ${item.color} transition-all`}
                style={{ width: `${Math.max(item.percentage, 0)}%` }}
              />
              {item.count > 0 && (
                <div className="absolute left-0 top-0 h-full flex items-center px-2">
                  <span className="text-xs font-medium text-white">
                    {item.count}
                  </span>
                </div>
              )}
            </div>
            
            {/* Percentage on right */}
            <span className="text-sm font-medium w-12 flex-shrink-0 text-right">
              {item.percentage}%
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
